import validate from "/app/node_modules/.pnpm/nuxt@4.5.1_d229e40015be0471a0521c4a5e460bd9/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/apps/web/app/middleware/auth.global.ts";
import require_45feature_45global from "/app/apps/web/app/middleware/require-feature.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.5.1_d229e40015be0471a0521c4a5e460bd9/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  require_45feature_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "super-admin": () => import("/app/apps/web/app/middleware/super-admin.ts")
}